import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { FlexColumnCenter, FlexColumn, SmallSemiBold, Tooltip, Map } from '@ubeya/shared-web/components';
import { ReactComponent as AdminReporterIcon } from '@ubeya/shared-web/assets/admin-reporter.svg';
import { ReactComponent as LocationReporterIcon } from '@ubeya/shared-web/assets/location.svg';
import useLocations from '@ubeya/shared/hooks/account/useLocations';
import useBranches from '@ubeya/shared/hooks/account/useBranches';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled.div`
  display: flex;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
  }
`;

const AdminWrapper = styled(FlexColumnCenter)`
  > div:first-child {
    font-weight: bold;
  }
  > div:last-child {
    font-weight: normal;
  }
`;

const MAP_REPORTER = {
  admin: AdminReporterIcon,
  location: LocationReporterIcon
};

const ReporterTooltip = ({ reporter, isJob, branchId, locationId }) => {
  const { t } = useContext(ConfigContext);
  const Icon = useMemo(() => MAP_REPORTER[reporter.type], [reporter.type]);

  const { mappedLocations } = useLocations();
  const { mappedBranches } = useBranches();
  const timeSheetLocation = useMemo(() => {
    if (isJob) {
      const branchLocationId = mappedBranches[branchId]?.locationId;
      return mappedLocations[branchLocationId];
    }
    return mappedLocations[locationId];
  }, [branchId, isJob, locationId, mappedBranches, mappedLocations]);

  const adminContent = useMemo(
    () => (
      <AdminWrapper>
        <SmallSemiBold>Captain</SmallSemiBold>
      </AdminWrapper>
    ),
    []
  );

  const locationContent = useMemo(
    () => (
      <FlexColumn>
        <Map
          allowShowAddress
          width={150}
          height={120}
          markers={[
            { lat: reporter?.lat, lng: reporter?.lng, title: t('userReportLocation') },
            { lat: timeSheetLocation?.lat, lng: timeSheetLocation?.lng, title: t('eventLocation') }
          ]}
        />
      </FlexColumn>
    ),
    [reporter?.lat, reporter?.lng, t, timeSheetLocation?.lat, timeSheetLocation?.lng]
  );

  return (
    <Tooltip body={reporter.type === 'admin' ? adminContent : locationContent} keepDisplayUponHover>
      <Wrapper>
        <Icon />
      </Wrapper>
    </Tooltip>
  );
};

export default ReporterTooltip;
